import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import asaLogoUrl from '../../images/header/asa-logo.svg';

const HeaderLogo = () => (
	<Button
		component={Link}
		to='/home'
		variant='outlined'
		className=' px-2 py-px sm:px-3 sm:py-1 xl:px-4  flex items-center space-x-2 xl:space-x-3'
	>
		<img src={asaLogoUrl} alt='Amr Saad Abdallah Logo' className='w-6 xl:w-8' />

		<Typography
			className='lowercase  text-xl sm:text-2xl xl:text-3xl'
			variant='h3'
			component='h2'
		>
			<span className='uppercase underline'>a</span>mr{' '}
			<span className='uppercase underline'>s</span>aad{' '}
			<span className='uppercase underline'>a</span>bdallah
		</Typography>
	</Button>
);

export default HeaderLogo;
